export const ENDPOINTS = {
  PERSONEL: {
    LIST: "/personeller",
    DETAIL: (id) => `/personeller/${id}`,
    TOGGLE_AKTIF: (id) => `/personeller/${id}/toggle-aktif`,
    ISTEN_CIKAR: (id) => `/personeller/${id}/isten-cikar`,

    IMPORT_EXCEL: "/personeller/import/excel",

    FILES: (id) => `/personeller/${id}/dosyalar`,
    FILE_DETAIL: (personelId, fileId) =>
      `/personeller/${personelId}/dosyalar/${fileId}`,
    FILE_DOWNLOAD: (personelId, fileId) =>
      `/personeller/${personelId}/dosyalar/${fileId}/indir`,
  },
  KURUM: {
    LIST: "/kurumlar",
    IMPORT: "/kurumlar/import",
  },
  DEPARTMAN: {
    LIST: "/departmanlar",
  },
  POZISYON: {
    LIST: "/pozisyonlar",
  },
  GENERAL: {
    LIST: "/media/general",
    UPLOAD: "/media/general",
    DETAIL: (filename) => `/media/general/${filename}`,
    DOWNLOAD: (filename) => `/media/general/${filename}`,
    DELETE: (filename) => `/media/general/${filename}`,
  },
  IZIN: {
    CREATE: "/izin",
    KURUM: "/izin/kurum",
    LIST_BY_PERSONEL: (id) => `/izin/${id}`,
  },
  PUANTAJ: {
    HAFTALIK: "/puantaj/haftalik",
    KAYDET: "/puantaj/kaydet",
    OZET: "/puantaj/ozet",
    PERSONEL: "/puantaj/personel",
    EXCEL: "/puantaj/excel",
  },
  STATS: {
    ADMIN: "/stats/admin",
    KURUM: (kurumId) => `/stats/kurum/${kurumId}`,
  },
  DOSYA_TURU: {
    LIST: "/dosya-turleri",
    DETAIL: (id) => `/dosya-turleri/${id}`,
  },
};